import { updateUserFirebase } from "./firebaseService";
// src/services/quizService.js
export async function submitAnonymous(payload) {
  // payload = { answers: [...], summaryFields: {...} }
  // Dev stub: retorna simulated result + previewToken
  // Replace with real fetch('/api/quiz/complete', { method:'POST', body: JSON.stringify(payload) })
  try {
    // Example of real call:
    // const res = await fetch('/api/quiz/complete', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(payload) });
    // return await res.json();

    // Simulated response:
    const fakeResult = {
      success: true,
      result: {
        personalityType: "breeze",
        archetype: {
          key: "navigator",
          label: "Navigator",
          description: "Observador",
        },
        insights: {
          temperamentStrengths: ["Clareza mental", "Visão ampla"],
          characterResources: ["Ações pequenas", "Desfusão"],
          recommendations: ["Regra dos 5 minutos", "Diário breve"],
          miniPlan: [
            { title: "Dia 1", text: "Observação sem julgamento (10 min)" },
            { title: "Dia 2", text: "Desfusão (5 min)" },
          ],
          weeklyQuestion: "O que você valoriza mais?",
        },
      },
      previewToken: "anon_preview_" + Math.random().toString(36).slice(2, 9),
      expiresIn: 3600,
    };
    // small delay to simulate network
    await new Promise((r) => setTimeout(r, 600));
    return fakeResult;
  } catch (err) {
    console.error("submitAnonymous error", err);
    throw err;
  }
}

// quizService.js (adicionar)
export async function convertAnonymous(previewToken, authToken) {
  // Chamada ao seu backend: troca token anônimo por dados atribuídos ao usuário autenticado.
  // Endpoint backend esperado: POST /api/quiz/convert { previewToken }  (auth required)
  try {
    const res = await fetch("/api/quiz/convert", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
      },
      body: JSON.stringify({ previewToken }),
    });
    if (!res.ok) {
      const txt = await res.text();
      throw new Error(`convertAnonymous failed: ${res.status} ${txt}`);
    }
    return await res.json(); // { success: true, userData: {...} }
  } catch (err) {
    console.warn("quizService.convertAnonymous error", err);
    throw err;
  }
}

/**
 * Tenta anexar o resultado anônimo ao usuário autenticado.
 * - previewToken (se houver) é preferível e tenta chamar backend convertAnonymous
 * - caso não exista backend, faz updateUserFirebase direto (client-side)
 *
 * @param {Object|null} payload - payload JSON salvo no localStorage (can be null)
 * @param {string|null} previewToken - token recebido do submitAnonymous (may be null)
 * @param {Object} user - objeto user do contexto (deve conter uid/id)
 * @param {string|null} authToken - token JWT (opcional)
 */
export async function attachAnonymousPayloadToUser(
  { payload, previewToken },
  userData,
  authToken = null
) {
  if (!userData || !userData.id) {
    throw new Error("attachAnonymousPayloadToUser: usuário não autenticado");
  }
  const uid = userData.id;

  // (tenta server convert via previewToken, se existir) ...
  // se falhar ou não houver previewToken, fallback:

  if (payload) {
    const toPersist = {
      id: uid,
      personalityTraits: payload.personalityTraits || null,
      personalityAudit: [
        ...(payload.personalityAudit || []),
        { action: "imported_anonymous", at: new Date().toISOString() },
      ],
      lastAnonymousPayload: payload,
    };
    const personalityTraits = payload.personalityTraits || null;

    const personalityAudit = [
      ...(payload.personalityAudit || []),
      { action: "imported_anonymous", at: new Date().toISOString() },
    ];

    const lastAnonymousPayload = payload;

    const updatedUserData = {
      ...userData,
      personalityTraits,
      personalityAudit,
      lastAnonymousPayload,
    };

    // chama updateUserFirebase (que agora usa setDoc merge)
    await updateUserFirebase(updatedUserData);
    return {
      success: true,
      updatedUserData: updatedUserData,
    };
  }

  return { success: false, reason: "no_preview_or_payload" };
}
